/**
 * Keyboard shortcut hints shown at the bottom of the planning views, built
 * at render time in the current language (keys stay in <kbd>, texts from t()).
 */
import { t } from '../../../shared/i18n/index.js';

const kbd = (key) => `<kbd>${key}</kbd>`;
const SEP = ' · ';

/** Hint lines (HTML) per view: bubble, mindmap, gantt, kanban. */
export function shortcutHintsHtml() {
  const sidebar = `${kbd('[')} ${t('views.hints.sidebar')}`;
  const edit = [
    `${kbd('A')}/${kbd('Tab')} ${t('views.hints.add')}`,
    `${kbd('Enter')} ${t('views.hints.editName')}`,
    `${kbd('E')} ${t('views.hints.editProps')}`,
    `${kbd('C')} ${t('views.hints.collapse')}`,
  ];
  const up = `${kbd('U')} ${t('views.hints.up')}`;
  const del = `${kbd('Del')} ${t('views.hints.delete')}`;
  const reparent = t('views.hints.ctrlDragReparent', { ctrl: kbd('Ctrl') });
  return {
    bubble: [sidebar, ...edit, up, del, reparent].join(SEP),
    mindmap: [
      sidebar, ...edit,
      `${kbd('W')} ${t('views.hints.executionList')}`,
      `${kbd('R')} ${t('views.hints.routinesPanel')}`,
      up, del, reparent, t('views.hints.doubleClickZoom'),
    ].join(SEP),
    gantt: [
      sidebar, up,
      t('views.hints.zoomKeys', { keys: kbd('+') + kbd('−'), alt: kbd('Alt') }),
      t('views.hints.dragMove'),
      t('views.hints.dragEdgesResize'),
    ].join(SEP),
    kanban: [sidebar, t('views.hints.dragCards'), t('views.hints.doubleClickEdit')].join(SEP),
  };
}

/** The bubble view's first hint line (before the viewer check runs). */
export function bubbleInitialHintHtml() {
  return [
    `${kbd('[')} ${t('views.hints.sidebar')}`,
    `${kbd('A')}/${kbd('Tab')} ${t('views.hints.add')}`,
    `${kbd('Enter')} ${t('views.hints.editName')}`,
    `${kbd('E')} ${t('views.hints.editProps')}`,
    `${kbd('C')} ${t('views.hints.collapse')}`,
    `${kbd('U')} ${t('views.hints.up')}`,
    `${kbd('Del')} ${t('views.hints.delete')}`,
    t('views.hints.ctrlDragRestructure', { ctrl: kbd('Ctrl') }),
  ].join(SEP);
}
